/* ============================================================
   Carrusel centrado en bucle — secciones 04 y 09

   Objetivo: que se sienta igual de suave que las cintas.
   Tres cosas lo consiguen:
   · las posiciones de las tarjetas se calculan UNA vez y se
     guardan; durante el desplazamiento solo se hace aritmética,
     nunca se vuelve a medir el DOM (eso era el tirón)
   · el imán de scroll-snap se desactiva mientras dura un
     desplazamiento provocado por el código, para que no pelee
     contra él
   · la tarjeta activa solo se repinta cuando cambia de verdad
   ============================================================ */
(function () {
  'use strict';

  var reduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    (root || document).querySelectorAll('[data-ba-cf]').forEach(function (cf) {
      if (cf.__ba) return;
      cf.__ba = true;

      var wrap = cf.closest('[data-ba-cf-wrap]') || cf.parentNode;
      var items = Array.prototype.slice.call(cf.querySelectorAll('.ba-cf__item'));
      var dots = Array.prototype.slice.call(wrap.querySelectorAll('[data-ba-dot]'));
      var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[data-ba-tab]'));
      if (!items.length) return;

      var stepDir = parseInt(cf.getAttribute('data-step-dir') || '1', 10) || 1;
      var every = parseInt(cf.getAttribute('data-autoplay') || '0', 10);

      var offsets = [];
      var lastActive = null;
      var loopOn = false;
      var paused = false;
      var visible = true;
      var resumeTimer, settleTimer, snapTimer, raf;

      function originals() {
        return items.filter(function (el) { return !el.hidden; });
      }

      /* Posiciones calculadas una sola vez */
      function cacheOffsets() {
        offsets = [];
        Array.prototype.forEach.call(cf.children, function (el) {
          if (el.hidden) return;
          offsets.push({ el: el, c: el.offsetLeft + el.offsetWidth / 2 });
        });
        lastActive = null;
      }

      function nearest() {
        if (!offsets.length) return null;
        var mid = cf.scrollLeft + cf.clientWidth / 2;
        var best = offsets[0].el;
        var bestD = Infinity;
        for (var i = 0; i < offsets.length; i++) {
          var d = offsets[i].c - mid;
          if (d < 0) d = -d;
          if (d < bestD) { bestD = d; best = offsets[i].el; }
        }
        return best;
      }

      /* El imán se aparta mientras el código mueve el carrusel */
      function releaseSnap(ms) {
        cf.style.scrollSnapType = 'none';
        clearTimeout(snapTimer);
        snapTimer = setTimeout(function () {
          cf.style.scrollSnapType = '';
        }, ms);
      }

      function goTo(el, smooth) {
        if (!el) return;
        var left = el.offsetLeft + el.offsetWidth / 2 - cf.clientWidth / 2;

        if (smooth === false || reduced) {
          releaseSnap(60);
          cf.scrollLeft = left;
          return;
        }
        releaseSnap(700);
        cf.scrollTo({ left: left, behavior: 'smooth' });
      }

      function sync() {
        var cur = nearest();
        if (cur === lastActive) return;

        if (lastActive) lastActive.classList.remove('is-active');
        if (cur) cur.classList.add('is-active');
        lastActive = cur;

        var active = cur ? cur.__i : 0;
        var k = 0;
        for (var i = 0; i < items.length; i++) {
          var dot = dots[i];
          if (!dot) continue;
          if (items[i].hidden) { dot.hidden = true; continue; }
          dot.hidden = false;
          dot.setAttribute('aria-current', k === active ? 'true' : 'false');
          k++;
        }
      }

      /* ----- Bucle: un juego de clones a cada lado ----- */
      function buildLoop() {
        Array.prototype.slice.call(cf.querySelectorAll('[data-ba-clone]')).forEach(
          function (n) { n.remove(); }
        );

        var vis = originals();
        loopOn = vis.length >= 2;

        if (loopOn) {
          vis.forEach(function (el) {
            var c = el.cloneNode(true);
            c.setAttribute('data-ba-clone', '1');
            c.setAttribute('aria-hidden', 'true');
            c.removeAttribute('hidden');
            cf.appendChild(c);
          });
          for (var i = vis.length - 1; i >= 0; i--) {
            var c2 = vis[i].cloneNode(true);
            c2.setAttribute('data-ba-clone', '1');
            c2.setAttribute('aria-hidden', 'true');
            c2.removeAttribute('hidden');
            cf.insertBefore(c2, cf.firstChild);
          }
        }

        var n = originals().length;
        var k = 0;
        Array.prototype.forEach.call(cf.children, function (el) {
          if (el.hidden) return;
          el.__i = n ? k % n : 0;
          k++;
        });

        cacheOffsets();
      }

      /* Al detenerse sobre un clon, saltamos a la tarjeta real.
         Es instantáneo y la imagen es idéntica: no se nota. */
      function recenter() {
        if (!loopOn) return;
        var el = nearest();
        if (!el || !el.hasAttribute('data-ba-clone')) return;
        var orig = originals()[el.__i];
        if (orig) goTo(orig, false);
      }

      function hold() {
        paused = true;
        clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () { paused = false; }, 6000);
      }

      function step(dir) {
        var cur = nearest();
        var idx = -1;
        for (var i = 0; i < offsets.length; i++) {
          if (offsets[i].el === cur) { idx = i; break; }
        }
        if (idx < 0) return;
        var next = idx + dir;
        if (next < 0) next = 0;
        if (next > offsets.length - 1) next = offsets.length - 1;
        goTo(offsets[next].el);
      }

      cf.addEventListener(
        'scroll',
        function () {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(sync);
          clearTimeout(settleTimer);
          settleTimer = setTimeout(recenter, 200);
        },
        { passive: true }
      );

      cf.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'mouse') paused = true;
      });
      cf.addEventListener('pointerleave', function (e) {
        if (e.pointerType === 'mouse') paused = false;
      });
      cf.addEventListener('touchstart', hold, { passive: true });

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          hold();
          if (!items[i].hidden) goTo(items[i]);
        });
      });

      var prev = wrap.querySelector('[data-ba-cf-prev]');
      var next = wrap.querySelector('[data-ba-cf-next]');
      if (prev) prev.addEventListener('click', function () { hold(); step(-1); });
      if (next) next.addEventListener('click', function () { hold(); step(1); });

      /* ----- Pestañas ----- */
      function applyTab(group) {
        items.forEach(function (el) {
          el.hidden = group !== 'todos' && el.getAttribute('data-group') !== group;
        });
        buildLoop();
        goTo(originals()[0], false);
        requestAnimationFrame(sync);
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
          });
          hold();
          applyTab(tab.getAttribute('data-ba-tab'));
        });
      });

      var startTab = tabs.filter(function (t) {
        return t.getAttribute('aria-selected') === 'true';
      })[0];
      if (startTab) {
        var g = startTab.getAttribute('data-ba-tab');
        items.forEach(function (el) {
          el.hidden = g !== 'todos' && el.getAttribute('data-group') !== g;
        });
      }

      buildLoop();
      requestAnimationFrame(function () {
        goTo(originals()[0], false);
        sync();
      });

      /* Las medidas cambian al cargar fuentes e imágenes */
      function refresh() {
        var el = nearest();
        var i = el ? el.__i : 0;
        cacheOffsets();
        goTo(originals()[i], false);
        sync();
      }

      window.addEventListener('load', refresh);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(refresh).catch(function () {});
      }

      var rz;
      window.addEventListener('resize', function () {
        clearTimeout(rz);
        rz = setTimeout(refresh, 250);
      });

      if (every && !reduced) {
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(
            function (e) { visible = e[0].isIntersecting; },
            { rootMargin: '100px' }
          ).observe(cf);
        }
        setInterval(function () {
          if (paused || !visible || document.hidden) return;
          step(stepDir);
        }, every);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
